import React, { useState } from "react";
import {
  Backdrop,
  Box,
  Button,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import * as Yup from "yup";
import { Formik } from "formik";
import ModalLoadingFull from "../../../components/modals/ModalLoadingFull";
import { useNavigate } from "react-router";
import { postNotification } from "../../../components/utilities/Notifications";
import { BCPXmark } from "../../../components/icons/bcp/BCPIcons";
import { postData } from "../../../components/utilities/UtilityFunctions";

export function ArmyListCopyModal(props) {
  const { open, setOpen, armyList, heading } = props;
  const navigate = useNavigate();

  const [processing, setProcessing] = useState(false);
  if (!open) return <></>;
  return (
    <>
      <Modal
        disableAutoFocus
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            maxHeight: "95vh",
            bgcolor: "background.paper",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 24,
            p: 4,
          }}
        >
          <IconButton
            aria-label="cancel"
            color="error"
            sx={{ position: "absolute", top: "4px", right: "4px" }}
            onClick={() => {
              setOpen(false);
            }}
          >
            <BCPXmark />
          </IconButton>
          <Grid
            container
            spacing={2}
            sx={{
              pb: 1,
              mb: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            }}
          >
            <Grid item xs>
              <Typography variant="h4" component="h2">
                {heading ||
                  `Copy ${armyList?.gameSystem?.listLabel || "Army List"}`}
              </Typography>
            </Grid>
          </Grid>
          <Formik
            initialValues={{
              name: `${
                armyList?.name ? `${armyList?.name} - ` : ""
              }Copy`.trim(),
              public: armyList?.public,
            }}
            validationSchema={Yup.object().shape({
              name: Yup.string()
                .min(3, "Minimum 3 Characters!")
                .max(255, "Maximum 255 Characters!")
                .required("Required"),
            })}
            enableReinitialize
            onSubmit={async (values) => {
              setProcessing(true);

              try {
                var copyArmyList = await postData(
                  `/armylists/${armyList?.id}/copy`,
                  {
                    body: values,
                  }
                );
                navigate(`/deck/${copyArmyList.id}/deck-builder`);
                return;
              } catch (err) {
                postNotification("error", err);
              }
              setProcessing(false);
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              touched,
              values,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      name="name"
                      label="Name"
                      value={values.name}
                      variant="outlined"
                      fullWidth
                      required
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={Boolean(touched.name && errors.name)}
                      helperText={touched.name && errors.name}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <FormControlLabel
                      label={
                        <Typography className="MuiFormControlLabel-label">
                          Public
                        </Typography>
                      }
                      sx={{
                        ml: 0,
                        width: "100%",
                        "& .MuiFormControlLabel-label": {
                          width: "calc(100% - 58px)",
                        },
                      }}
                      control={
                        <Switch
                          color="primary"
                          checked={values.public}
                          onChange={(e) => {
                            setFieldValue("public", !values.public);
                          }}
                        />
                      }
                      labelPlacement="start"
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="error"
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="success"
                      type="submit"
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </Box>
      </Modal>
      {processing && <ModalLoadingFull />}
    </>
  );
}
